import { StyleSheet, css } from 'aphrodite'
import type { ButtonHTMLAttributes } from 'react'
import type React from 'react'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  className?: string
}

const Button: React.FC<ButtonProps> = ({ children, className, ...rest }) => {
  return (
    <button
      className={`${css(
        styles.button,
        rest.disabled && styles.disabled,
      )} ${className}`}
      {...rest}
    >
      {children}
    </button>
  )
}

const styles = StyleSheet.create({
  button: {
    backgroundColor: '#1C64F2',
    color: '#FFFFFF',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 'bold',
    transition: 'background-color 0.3s ease',
    ':hover': {
      backgroundColor: '#0056b3',
    },
    height: '48px',
  },
  disabled: {
    backgroundColor: '#cccccc',
    cursor: 'not-allowed',
    ':hover': {
      backgroundColor: '#cccccc',
    },
  },
})

export default Button
